import { componentQrl, inlinedQrl, _jsxBranch, useComputedQrl, useLexicalScope, useSignal, useStore, useVisibleTaskQrl, _jsxQ, _jsxS, _fnSignal, _jsxC, Slot } from "@builder.io/qwik";
const Video = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  _jsxBranch();
  const videoProps = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    return {
      ...props2.autoPlay === true ? {
        autoPlay: true
      } : {},
      ...props2.muted === true ? {
        muted: true
      } : {},
      ...props2.controls === true ? {
        controls: true
      } : {},
      ...props2.loop === true ? {
        loop: true
      } : {},
      ...props2.playsInline === true ? {
        playsInline: true
      } : {}
    };
  }, "Video_component_videoProps_useComputed_60AadUGY06E", [
    props
  ]));
  const spreadProps = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [videoProps2] = useLexicalScope();
    return {
      ...videoProps2.value
    };
  }, "Video_component_spreadProps_useComputed_ZdLsx18NYH4", [
    videoProps
  ]));
  const videoRef = useSignal();
  const state = useStore({
    lazyVideoObserver: void 0
  });
  useVisibleTaskQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2, state2, videoRef2] = useLexicalScope();
    if (props2.lazyLoad) {
      const oberver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting)
            return;
          const videoElement = entry.target;
          try {
            Array.from(videoElement.children).filter((child) => child instanceof HTMLElement && child.tagName === "SOURCE").forEach((source) => {
              const src = source.dataset.src;
              if (src)
                source.src = src;
            });
            videoElement.load();
            oberver.unobserve(videoElement);
          } catch (error) {
            console.error("Error loading lazy video:", error);
          }
        });
      });
      if (videoRef2.value)
        oberver.observe(videoRef2.value);
      state2.lazyVideoObserver = oberver;
    }
  }, "Video_component_useVisibleTask_LdYTuni7vo4", [
    props,
    state,
    videoRef
  ]));
  return /* @__PURE__ */ _jsxQ("div", null, {
    style: {
      position: "relative"
    }
  }, [
    /* @__PURE__ */ _jsxS("video", {
      ...spreadProps.value,
      children: /* @__PURE__ */ _jsxS("source", {
        ...props.lazyLoad ? {
          "data-src": props.video
        } : {
          src: props.video
        }
      }, {
        type: "video/mp4"
      }, 0, null),
      ref: videoRef,
      style: {
        width: "100%",
        height: "100%",
        ...(_a = props.attributes) == null ? void 0 : _a.style,
        objectFit: props.fit,
        objectPosition: props.position,
        // Hack to get object fit to work as expected and
        // not have the video overflow
        borderRadius: "1px",
        ...props.aspectRatio ? {
          position: "absolute"
        } : null
      }
    }, {
      class: "builder-video",
      poster: _fnSignal((p0) => p0.posterImage, [
        props
      ], "p0.posterImage"),
      preload: _fnSignal((p0) => p0.lazyLoad ? "none" : p0.preload || "metadata", [
        props
      ], 'p0.lazyLoad?"none":p0.preload||"metadata"')
    }, 0, null),
    props.aspectRatio && !(props.fitContent && ((_c = (_b = props.builderBlock) == null ? void 0 : _b.children) == null ? void 0 : _c.length)) ? /* @__PURE__ */ _jsxQ("div", null, {
      style: _fnSignal((p0) => ({
        width: "100%",
        paddingTop: p0.aspectRatio * 100 + "%",
        pointerEvents: "none",
        fontSize: "0px"
      }), [
        props
      ], '{width:"100%",paddingTop:p0.aspectRatio*100+"%",pointerEvents:"none",fontSize:"0px"}')
    }, null, 3, "j7_0") : null,
    ((_e = (_d = props.builderBlock) == null ? void 0 : _d.children) == null ? void 0 : _e.length) && props.fitContent ? /* @__PURE__ */ _jsxQ("div", null, {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
      }
    }, /* @__PURE__ */ _jsxC(Slot, null, 3, "j7_1"), 1, "j7_2") : null,
    ((_g = (_f = props.builderBlock) == null ? void 0 : _f.children) == null ? void 0 : _g.length) && !props.fitContent ? /* @__PURE__ */ _jsxQ("div", null, {
      style: {
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%"
      }
    }, /* @__PURE__ */ _jsxC(Slot, null, 3, "j7_3"), 1, "j7_4") : null
  ], 1, "j7_5");
}, "Video_component_qdcTZflYyoQ"));
export {
  Video,
  Video as default
};
